export default "__VITE_ASSET__Dcp9EAnj__"